import { path } from 'ramda'

export default (ownProps, paramName) => path(['match', 'params', paramName])(ownProps)
